import { tiptapTranslations } from '@adornis/tiptap/translations.js';
import { clientTranslator } from '@adornis/translation-core/client/clientTranslator.js';
import { Language } from '@adornis/translation-core/languages.js';

const translations = {
  ...tiptapTranslations,

  tables: ['Tabellen', 'Tables'],
  headings: ['Überschriften', 'Headings'],

  privacy: ['Datenschutzerklärung', 'Privacy'],
  imprint: ['Impressum', 'Imprint'],
  accessibility: ['Barrierefreiheit', 'Accessibibility'],

  userManagement: ['Nutzermanagement', 'User Management'],
  createNewPage: ['Neue Seite erstellen', 'Create new Page'],

  openSidebar: ['Seitenleiste öffnen', 'Open Sidebar'],
  welcome: ['Willkommen', 'Welcome'],
  welcomeToOctipad: ['Willkommen zu OctiPad', 'Welcome to OctiPad'],
  logout: ['Ausloggen', 'Logout'],
  login: ['Einloggen', 'Login'],
  help: ['Hilfe', 'Help'],
  collaborativeWriting: ['Kollaboratives Schreiben', 'Collaborative Writing'],
  ownerSettings: ['Besitzereinstellungen', 'Owner Settings'],

  accessDenied: ['Zugriff verweigert', 'Access Denied'],

  button: {
    add: ['Hinzufügen', 'Add'],
    edit: ['Bearbeiten', 'Edit'],
    delete: ['Löschen', 'Delete'],
    accept: ['Akzeptieren', 'Accept'],
    confirmUserDelete: ['Möchten Sie diesen Benutzer wirklich löschen?', 'Are you sure you want to delete this user?'],
    back: ['Zurück', 'Back'],
  },

  editor: {
    characters: ['Zeichen', 'Characters'],
    words: ['Wörter', 'Words'],
    connected: ['Verbunden', 'Connected'],
    comments: ['Kommentare', 'Comments'],
    current: ['Aktuell', 'Current'],
    versionsRecorded: ['Versionen aufgezeichnet', 'Versions recorded'],
    versionBack: ['Vorherige Version', 'Previous version'],
    versionCurrent: ['Aktuelle Version', 'Current version'],
    versionAhead: ['Nächste Version', 'Next version'],
  },

  acceptLegal: {
    iAccept: ['Ich akzeptiere die Datenschutzrichtlinie', 'I accept the privacy policy'],
    pleaseRead: ['Bitte lesen Sie unsere', 'Please read our'],
    privacyPolicy: ['Datenschutzrichtlinie', 'Privacy Policy'],
  },

  permissionEditor: {
    addPermission: ['Berechtigung hinzufügen', 'Add Permission'],
  },

  field: {
    username: ['Nutzername', 'Username'],
    email: ['E-Mail', 'E-Mail'],
    password: ['Passwort', 'Password'],
    permissionType: ['Berechtigungstyp', 'Permission Type'],
  },

  passwordInfo: [
    'Das Passwort muss mindestens 8 Zeichen, einen Großbuchstaben, einen Kleinbuchstaben, eine Zahl und ein Sonderzeichen enthalten.',
    'Password must contain at least 8 characters, one uppercase letter, one lowercase, one number and one special character.',
  ],

  error: {
    passwordCriteria: [
      'Das Passwort entspricht nicht den erforderlichen Kriterien.',
      'Password does not match the required criteria.',
    ],
    emailCriteria: [
      'Die E-Mail entspricht nicht den erforderlichen Kriterien.',
      'E-Mail does not match the required criteria.',
    ],
    usernamePasswordRequired: ['Nutzername und E-Mail sind erforderlich.', 'Username and E-Mail are required.'],
  },
} as const;

export type DlaTranslationDict = typeof translations;

clientTranslator.updateDictionary(translations, [Language.GERMAN, Language.ENGLISH]);
